import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { getImg } from 'lib/utils';
import ImgLoader from 'components/common/Loaders/ImgLoader';
import Icon from 'components/common/Icon';
import { CUTTING_IMAGES, TabLinks } from '../../constants';
import { TabsLinks } from '../TabLinks';

import '../../EducationPage.scss';

const Cutting = (): JSX.Element => {
  return (
    <>
      <div className="education-page-img__container grid-area-cover-image-container">
        <ImgLoader
          folder="education-imgs/"
          images={CUTTING_IMAGES}
          name="education-img-cover-cutting"
        >
          <TransitionGroup component={null}>
            <CSSTransition
              appear
              timeout={400}
              classNames="switch-transparency"
            >
              <div
                className="grid-area-cover-image cutting"
                style={{
                  backgroundImage: `url(${getImg(
                    'education-imgs/',
                    CUTTING_IMAGES,
                    'education-img-cover-cutting',
                  )})`,
                }}
              ></div>
            </CSSTransition>
          </TransitionGroup>
        </ImgLoader>
      </div>

      <div className="grid-area-tabs block-scrollbar block-scrollbar_margin-right">
        <div className="tabs_container">
          <TabsLinks activeTab={TabLinks.CUT} />

          <div className="tabs-panels block-scrollbar">
            <div className="panel">
              <div className="panel-header">
                <Icon id="gem_light" />
                <h1 className="panel-header__title">DIAMOND CUT</h1>
              </div>
              <div className="panel-text-block">
                <p>
                  A diamond’s cut is often thought of as the shape of the
                  diamond, but it is actually defined as how well a diamond’s
                  facets interact with light. Symmetry, polish, and girdle size
                  are also factors in the cut grade of a diamond.
                </p>
              </div>
              <div className="panel-imgs-wrap">
                <div className="four-imgs-in-block">
                  <div>
                    <Icon id="cuttingA" />
                  </div>
                  <div>
                    <Icon id="cuttingB" />
                  </div>
                  <div>
                    <Icon id="cuttingC" />
                  </div>
                  <div>
                    <Icon id="cuttingD" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cutting;
